module.exports = __webpack_public_path__ + "img/logout.bb84875b.svg";